import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2026-10-08T13:59:11-0400.
 */
export function useTenantAdminCompanyRoleEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.TenantAdminCompanyRole,
    false
  );

  return Boolean(isEnabled);
}
